// extracted by mini-css-extract-plugin
export default {"container":"main_container__5GFbY","adfit":"main_adfit__ogBEv"};